import React from 'react'
import InnerHaeder from '../Component/InnerHaeder'
import Highlights from '../Component/Highlights'
import Footer from '../Component/Footer'
import { Link } from 'react-router-dom'
import HeadTag from '../Component/HeadTags'
const StudentStrength = () => {
  return (
    <>
      <HeadTag title="Student Strength" />
      <Highlights />
      <InnerHaeder />
      <div className="inner_page">
        <div className="container-fluid flwidth">
          <div className="bgimage">
            <h5><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link><span> About Us <i className="fas fa-angle-right"></i>  Student Strength </span></h5>
            <h2>Student Strength (2026-27)</h2>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="innertable">
                <table width="100%" cellpadding="0" cellspacing="0">
                  <thead>
                    <tr>
                      <th>CLASS </th>
                      {/* <th>NUMBER OF SECTIONS </th> */}
                      <th>NUMBER OF STUDENTS </th>
                    </tr>
                  </thead>

  <tbody>
                    <tr>
                      <td>NUR</td>
                      <td>231</td>
                    </tr>
                    <tr>
                      <td>LKG</td>
                      <td>239</td>
                    </tr>
                    <tr>
                      <td>KG</td>
                      <td>235</td>
                    </tr>
                    <tr>
                      <td>I</td>
                      <td>225</td>
                    </tr>
                    <tr>
                      <td>II</td>
                      <td>277</td>
                    </tr>
                    <tr>
                      <td>III</td>
                      <td>252</td>
                    </tr>
                    <tr>
                      <td>IV</td>
                      <td>253</td>
                    </tr>
                    <tr>
                      <td>V</td>
                      <td>248</td>
                    </tr>
                    <tr>
                      <td>VI</td>
                      <td>282</td>
                    </tr>
                    <tr>
                      <td>VII</td>
                      <td>250</td>
                    </tr>
                    <tr>
                      <td>VIII</td>
                      <td>233</td>
                    </tr>
                    <tr>
                      <td>IX</td>
                      <td>227</td>
                    </tr>
                    <tr>
                      <td>X</td>
                      <td>147</td>
                    </tr>
                    <tr>
                      <td>XI</td>
                      <td>125</td>
                    </tr>
                    <tr>
                      <td>XII</td>
                      <td>108</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td><strong>3332</strong></td>
                    </tr>
                  </tbody>

                  {/* <tbody>
                    <tr>
                      <td>NURSERY</td>
                      <td>6</td>
                      <td>175</td>
                    </tr>
                    <tr>
                      <td>LKG</td>
                      <td>8</td>
                      <td>233</td>
                    </tr>
                    <tr>
                      <td>KG</td>
                      <td>5</td>
                      <td>149</td>
                    </tr>
                    <tr>
                      <td>I</td>
                      <td>9</td>
                      <td>266</td>
                    </tr>
                    <tr>
                      <td>II</td>
                      <td>8</td>
                      <td>250</td>
                    </tr>
                    <tr>
                      <td>III</td>
                      <td>8</td>
                      <td>256</td>
                    </tr>
                    <tr>
                      <td>IV</td>
                      <td>8</td>
                      <td>255</td>
                    </tr>
                    <tr>
                      <td>V</td>
                      <td>9</td>
                      <td>281</td>
                    </tr>
                    <tr>
                      <td>VI</td>
                      <td>8</td>
                      <td>247</td>
                    </tr>
                    <tr>
                      <td>VII</td>
                      <td>7</td>
                      <td>215</td>
                    </tr>
                    <tr>
                      <td>VIII</td>
                      <td>7</td>
                      <td>212</td>
                    </tr>
                    <tr>
                      <td>IX</td>
                      <td>5</td>
                      <td>149</td>
                    </tr>
                    <tr>
                      <td>X</td>
                      <td>4</td>
                      <td>121</td>
                    </tr>
                    <tr>
                      <td>XI</td>
                      <td>4</td>
                      <td>110</td>
                    </tr>
                    <tr>
                      <td>XII</td>
                      <td>4</td>
                      <td>102</td>
                    </tr>
                    <tr>
                      <td><strong>Total</strong></td>
                      <td colspan={2}><strong>3021</strong></td> 
                    </tr>
                    <tr>
                      <td></td>
                      <td><b>90</b></td>
                      <td><b>2674</b></td>
                    </tr>

                  </tbody> */}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default StudentStrength
